export default "__VITE_ASSET__21PblWKN__"